import React from "react";
import readXlsxFile from 'read-excel-file'
import EditStudentForm from './EditStudentForm';
import $, { data } from 'jquery';
import config from '.././config.json';
import DatePickerDropdown from '.././Registration/DatePickerDropdown';
import { Redirect } from 'react-router';
import usStates from '../usStates';
import { JSONToCSVConvertor } from '../Helpers/ExportToExcel';
import {
    Form, Select, Tooltip,
    DatePicker, InputNumber, Spin, notification, Modal, Table, Input, Popconfirm,
} from 'antd';
import {
    Link
} from 'react-router-dom';
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
    },
};

const shortFormItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 4 },
        sm: { span: 3 },
    },
};

const midFormItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 12 },
        sm: { span: 8 },
    },
};

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 6,
        },
    },
};

const FormItem = Form.Item;
const Option = Select.Option;

class ImportForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedFile: null,
            fileData: null,
            enableInput: false,
            studentSearch: [],
            searchValue: '',
            searchPlaceholder: '',
            current: 1,
            employerValue: '',
            classValue: '',
            employerList: [],
            classList: []
        };
        this.stateList = usStates.listofUSstates();

        this.employerDisplayList = [];
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/registration/getallemployer`,
        })
            .done((data) => {
                this.setState({ employerList: data });
                for (let i = 0; i < data.length; i++) {
                    var optDis = data[i].CompanyName + ", " + data[i].City + " (" + data[i].State + ")";
                    this.employerDisplayList.push(
                        <Option key={data[i].Id} value={data[i].Id.toString()}>{optDis}</Option>
                    );
                }
            })
            .fail((jqXhr) => {
                console.log('failed to get employer');
            });

        this.fileList = [];
        this.getStudentData();
        this.setState({ current: 1 })

        this.classDisplayList = [];
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/classes/getall`,
        })
            .done((data) => {
                this.setState({ classList: data });
                for (let i = 0; i < data.length; i++) {
                    var optDis = data[i].Name + ", " + data[i].City + " (" + data[i].EndDate.substring(0, data[i].EndDate.indexOf('T')) + ")";
                    this.classDisplayList.push(
                        <Option key={data[i].Id} value={data[i].Id.toString()}>{optDis}</Option>
                    );
                }
            })
            .fail((jqXhr) => {
                console.log('failed to get classes');
            });
        alert("This page will display students that have been uploaded through files but not fully imported into the database yet. Click 'edit', fill out the information required, and click submit to finish importing their registration data ")

    }

    getStudentData() {
        this.setState({ current: 1 })

        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getImported`,
        })
            .done((data) => {
                var newData = []
                for (let i = 0; i < data.length; i++) {
                    newData.push(data[i])
                }
                this.setState({ fileData: newData, allStudents: newData })
                let fileNames = []
                this.fileList.push(
                    <Option key="all" value="all">All</Option>
                )
                for (let x = 0; x < data.length; x++) {
                    if (!fileNames.includes(data[x].ExcelName)) {
                        fileNames.push(data[x].ExcelName)
                        this.fileList.push(
                            <Option key={data[x].ExcelName} value={data[x].ExcelName}>{data[x].ExcelName}</Option>
                        )
                    }
                }
            })
            .fail((jqXhr) => {
                console.log('failed to get employer');
            });
    }

getDateOfBirthNew = (date) => {
        this.props.form.setFieldsValue({
            ['dob']: date,
        });
    }

    onFileChange = event => {
        const file = event.target.files[0];

        if (file == undefined) { return; }

        if (file.name.split('.').pop().toLowerCase() !== 'xlsx') {
            alert('Please upload a valid .xlsx file.');
            return;
        }

        // Update the state
        this.setState({ selectedFile: file });
        readXlsxFile(file).then((rows) => {
            var newData = this.formatData(rows)
            for (let x = 0; x < newData.length; x++) {
                newData[x].ExcelName = file.name
                newData[x].Uploaded = false;
            }
            $.ajax({
                type: 'POST',
                url: `${config.serverUrl}/api/students/uploadExcel/`,
                data: { Students: newData }
            })
                .done((data) => {
                    alert("File uploaded")
                    this.fileList = []
                    this.getStudentData();
                })
                .fail((jqXHR, textStatus, errorThrown) => {
                    console.log('failed to get data');
                });
            // `rows` is an array of rows
            // each row being an array of cells.
        })

    };

    handleChangeSort = (pagination, filters, sorter) => {
        this.setState({
            sortedInfo: sorter,
        });
    }

    edit(record) {
        this.setState({
            studentSearch: [],
            searchValue: '',
            searchPlaceholder: ''
        })
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getStudentByEmail/`,
            data: { email: record.Email }
        })
            .done((data) => {
                if (data.length != 0) {
                    this.setState({
                        student: data[0],
                        enableInput: true,
                        existing: true,
                    })
                
                    this.state.student.Organization = record.Organization;
                    this.state.student.Class = record.Class;
                    let classValue = this.state.classList.find(x => x.Name == record.Class);
                    let employerValue = this.state.employerList.find(x => x.CompanyName + ", " + x.City + " (" + x.State + ")" == record.Organization || x.CompanyName == record.Organization);

                    classValue &&
                        this.setState({ classID: classValue.Id, classValue: classValue.Name + ", " + classValue.City + " (" + classValue.EndDate.substring(0, classValue.EndDate.indexOf('T')) + ")" });

                    employerValue &&
                        this.setState({ empID: employerValue.Id, employerValue: employerValue.CompanyName + ", " + employerValue.City + " (" + employerValue.State + ")" })

                } else {
                    this.setState({
                        student: record,
                        enableInput: false,
                        existing: false
                    })
                }
                this.setState({
                    studentEdit: true,
                    loading: false,
                    excel: record.ExcelName
                });
                console.log(this.state.excel)
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('failed to get data');
            });

    }

    delete(record) {
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/students/deleteImport/`,
            data: record
        })
            .done((data) => {
                this.fileList = []
                this.getStudentData()
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('failed to get data');
            });
    }

    formatData = (data) => {

        let newData = [];

        for (let x = 1; x < data.length; x++) {
            if (data[x][4] == null) {
                data[x][4] = "N/A";
            }
            if (data[x][0] == null) {
                data[x][0] = "N/A";
            }
            if (data[x][1] == null) {
                data[x][1] = "N/A";
            }
            let row = { FirstName: data[x][0], LastName: data[x][1], Organization: data[x][2], PhoneNumber: data[x][3], Email: data[x][4], Class: data[x][5] };
            newData.push(row)
        }

        return newData
    }

    compareByChar(a, b) { if (a > b) { return -1; } if (a < b) { return 1; } return 0; }

    fileData = () => {

        let { sortedInfo } = this.state;
        sortedInfo = sortedInfo || {};
        let id = 'testButton'

        const columns = [
            {
                title: '',
                dataIndex: 'Index',
                render: (text, record, index) => {
                    return (
                        <span>
                            {((this.state.current - 1) * 30) + index + 1}
                        </span>
                    );
                }
            },
            {
                title: 'First Name',
                dataIndex: 'FirstName',
                key: 'FirstName',
                sorter: (a, b) => this.compareByChar(a.FirstName, b.FirstName),
                sortOrder: sortedInfo.columnKey === 'FirstName' && sortedInfo.order
            },

            {
                title: 'Last Name',
                dataIndex: 'LastName',
                key: 'LastName',
                sorter: (a, b) => this.compareByChar(a.LastName, b.LastName),
                sortOrder: sortedInfo.columnKey === 'LastName' && sortedInfo.order
            },

            {
                title: 'Organization',
                dataIndex: 'Organization',
                key: 'Organization',
                sorter: (a, b) => this.compareByChar(a.Organization, b.Organization),
                sortOrder: sortedInfo.columnKey === 'Organization' && sortedInfo.order
            },

            {
                title: 'Action',
                dataIndex: 'edit',
                render: (text, record, index) => {
                    return (
                        <span>
                            {(record.Email != "N/A" && record.FirstName != "N/A" && record.LastName != "N/A") && <a onClick={() => this.edit(record)}>Edit </a>}
                            {(record.Email != "N/A" && record.FirstName != "N/A" && record.LastName != "N/A") && <Popconfirm title="Are you sure you want to delete this record?" onConfirm={() => { this.delete(record) }} okText="Yes" cancelText="No">
                                <a> Delete</a>
                            </Popconfirm>}
                            {/*(record.Email == "N/A" || record.FirstName == "N/A" || record.LastName == "N/A") && 
                                <Popconfirm title="This record should be deleted because it is misssing data." onConfirm={() => { this.delete(record) }} okText="Confirm" cancelText="Cancel">
                                <a style={{ color: 'red' }}> Delete</a>
                    </Popconfirm>*/}
                            {(record.Email == "N/A" || record.FirstName == "N/A" || record.LastName == "N/A") &&
                                <Tooltip placement="right" overlay={<span>This record is missing data and should be deleted.</span>}>
                                    <Popconfirm d title="Delete this record?" onConfirm={() => { this.delete(record) }} okText="Confirm" cancelText="Cancel">
                                        <a style={{ color: 'red' }}> Delete</a>
                                    </Popconfirm>
                                </Tooltip>}

                        </span>
                    );
                }
            }
        ];

        if (this.state.fileData) {

            return (
                <div>
                    {this.state.studentEdit && this.editStudentForm()}
                    {!this.state.studentEdit && <Table rowKey="Id" bordered columns={columns}
                        dataSource={this.state.fileData}
                        pagination={{ pageSize: 30, current: this.state.current, onChange: (page, pageSize) => { this.setState({ current: page }) } }}
                        onChange={this.handleChangeSort}
                    />}

                </div>
            );
        } else {
            return (
                <div></div>
            );
        }
    };

    getEmployerId = (value) => {
        this.setState({
            empID: value
        });
    }

    getClassId = (value) => {
        this.setState({
            classID: value
        });
    }

    filterStudents = (value) => {
        if (value == "all") {
            this.setState({ fileData: this.state.allStudents })
            return;
        }
        let temp = []
        for (let x = 0; x < this.state.allStudents.length; x++) {
            if (this.state.allStudents[x].ExcelName == value) {
                temp.push(this.state.allStudents[x])
            }
        }

        this.setState({ fileData: temp })
    }

    exportExcel() {
        let headers = {
            fname: "FirstName",
            lname: "LastName",
            org: "Organization",
            phone: "Phone",
            email: "Email",
            class: "Class"
        }

        let items = [];
        items.push({ FirstName: '', LastName: '', Organization: '', Phone: '', Email: '', Class: '' })
        let fileTitle = 'StudentImportTemplate'

        items.unshift(headers);

        // Convert Object to JSON
        var jsonObject = JSON.stringify(items);

        var csv = this.convertToCSV(jsonObject);

        var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, exportedFilenmae);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilenmae);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    convertToCSV(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = '';

        for (var i = 0; i < array.length; i++) {
            var line = '';
            for (var index in array[i]) {
                if (line != '') line += ','

                line += array[i][index];
            }

            str += line + '\r\n';
        }

        return str;
    }

    handleSubmit = (e) => {
        if (this.state.validTechID == false) { alert("Invalid TechID"); } else {
            e.preventDefault();
            this.props.form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    //Format the data to be recieved by the server
                    var formObj = {
                        FirstName: values.fname,
                        LastName: values.lname,
                        MiddleInitial: values.mname,
                        DLN: values.dln,
                        DateofBirth: values.dob,
                        StreetAddress: values.street,
                        State: values.state,
                        City: values.city,
                        ZipCode: values.zipcode,
                        PhoneNumber: values.phone,
                        Email: values.email,
                        TechID: values.techID
                    }

                    var emp = {
                        Id: this.state.empID,
                        CompanyName: null,
                        Address: null,
                        State: null,
                        City: null,
                        ZipCode: null,
                        PhoneNumber: null,
                        Email: null,
                    }

                    var studID = null;

                    if (!this.state.existing) {
                        let studEmp = { stud: formObj, emp: emp };
                        $.ajax({
                            type: 'POST',
                            url: `${config.serverUrl}/api/registration/student`,
                            contentType: "application/json; charset=utf-8",
                            data: JSON.stringify(studEmp)
                        })
                            .done((data) => {
                                //console.log(data);
                                $.ajax({
                                    type: 'GET',
                                    url: `${config.serverUrl}/api/students/getStudentByEmail/`,
                                    data: { email: formObj.Email }
                                })
                                    .done((data) => {
                                        if (data.length != 0) {
                                            this.state.student.Id = data[0].Id
                                            this.enrollExisting(formObj, this.state.classID)
                                        }
                                    })
                                    .fail((jqXHR, textStatus, errorThrown) => {
                                        console.log('failed to get data');
                                    });
                            })
                            .fail((jqXhr) => {
                                console.log('failed to register');
                                this.setState({
                                    loading: false
                                });
                                const modal2 = Modal.error({
                                    title: "Student registration failed!",
                                    content: 'Server Error',
                                });
                            });
                        $.ajax({
                            type: 'GET',
                            url: `${config.serverUrl}/api/students/getStudentByEmail/`,
                            data: { email: formObj.Email }
                        })
                            .done((data) => {
                                if (data.length != 0) {
                                    this.state.student.Id = data[0].Id
                                    this.enrollExisting(formObj, values.class)
                                }
                            })
                            .fail((jqXHR, textStatus, errorThrown) => {
                                console.log('failed to get data');
                            });
                    } else {
                        this.enrollExisting(formObj, this.state.classID)
                    }
                }
            });
        }
    }

    enrollExisting(formObj, classId) {
        var enroll = {
            Id: 0,
            StudentId: this.state.student.Id,
            ClassId: classId,
            GradesId: null,
            EnrllmentConfirm: null,
            Paid: null,
            RegisterTime: null,
            Email: null,
        }
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/registration/external`,
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(enroll)
        })
            .done((data) => {
                this.state.student.ExcelName = this.state.excel
                $.ajax({
                    type: 'POST',
                    url: `${config.serverUrl}/api/students/updateImport`,
                    data: this.state.student
                })
                    .done((data) => {
                        this.fileList = []
                        this.getStudentData()
                    })
                    .fail((jqXhr) => {
                        console.log('Failed update import')
                    });
                const modal = Modal.success({
                    title: "Student registration successful!",
                    content: 'They will now be registered for this class.',
                    onOk() {

                    }
                });
            })
            .fail((jqXhr) => {
                console.log('failed to register');
                const modal2 = Modal.error({
                    title: "Student registration failed!",
                    content: 'Server Error',
                });
            });
        this.setState({
            studentEdit: false
        })
    }

    searchForStudent = () => {
        if (this.state.searchValue.length < 1) {
            $.ajax({
                type: 'POST',
                url: `${config.serverUrl}/api/students/searchlastname`,
                data: { lastname: this.state.student.LastName }
            })
                .done((result) => {
                    console.log(result);
                    if (result.length > 0) {
                        this.setState({ searchPlaceholder: result[0].FirstName + " " + result[0].MiddleInitial + " " + result[0].LastName })
                        for (let x = 0; x < result.length; x++) {
                            console.log(result[x])
                            this.state.studentSearch.push(<Option key={result[x].StudentId} value={result[x].StudentId}>{result[x].FirstName + " " + result[x].MiddleInitial + " " + result[x].LastName}</Option>)
                        }
                    }

                })
                .fail((jqXhr) => {
                    console.log('failed to get category');
                });
            return;
        }
        this.setState({ studentSearch: [] })

        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/students/searchlastname`,
            data: { lastname: this.state.searchValue }
        })
            .done((result) => {
                console.log(result);
                if (result.length > 0) {
                    this.setState({ searchPlaceholder: result[0].FirstName + " " + result[0].MiddleInitial + " " + result[0].LastName })
                    for (let x = 0; x < result.length; x++) {
                        console.log(result[x])
                        this.state.studentSearch.push(<Option key={result[x].StudentId} value={result[x].StudentId}>{result[x].FirstName + " " + result[x].MiddleInitial + " " + result[x].LastName}</Option>)
                    }
                }

            })
            .fail((jqXhr) => {
                console.log('failed to get category');
            });
    }

    updateSearch = (event) => {
        this.setState({ searchValue: event.target.value })
    }

    updateForm = (value) => {
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getstudentbyid`,
            data: { id: value }
        })
            .done((result) => {
                result.Organization = this.state.student.Organization
                result.Class = this.state.student.Class
                result.Email = this.state.student.Email
                this.setState({ student: result, existing: true })
            })
            .fail((jqXhr) => {
                console.log('failed to get category');
            });
    }

    editStudentForm = () => {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <div>
                    <Spin spinning={this.state.loading}>
                        <h2>Edit Student</h2>
                        <hr />
                        <ul className='searchList'>
                            <li>
                                <label>Search By Student Name: </label>
                            </li>
                            <li>
                                <input disabled={this.state.enableInput} defaultValue={this.state.student.LastName} onChange={this.updateSearch} />
                            </li>
                            <li>
                                <button disabled={this.state.enableInput} onClick={this.searchForStudent} className="btn btn-default">Search</button>
                            </li>
                        </ul>
                        <ul className='searchList'>
                            <li>
                                <label>Select a Student: </label>
                            </li>
                            <li>
                                <Select
                                    showSearch
                                    style={{ width: '250px' }}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    disabled={this.state.enableInput}
                                    placeholder={this.state.searchPlaceholder}
                                    onChange={this.updateForm}
                                >
                                    {this.state.studentSearch}
                                </Select>
                            </li>
                        </ul>
                        <hr />
                        <Form onSubmit={this.handleSubmit}>

                            <div className='forms'>
                                {/*------------------------------------------ User Details ------------------------------------------*/}
                                <FormItem {...formItemLayout} label="First Name" >
                                    {getFieldDecorator('fname', {
                                        initialValue: this.state.student.FirstName,
                                    })(<Input disabled="disabled" />)}
                                </FormItem>
                                {/*TODO: Limit one character*/}
                                <FormItem {...shortFormItemLayout} label="Middle Initial" >
                                    {getFieldDecorator('mname', {
                                        initialValue: this.state.student.MiddleInitial,
                                    })(<Input disabled={this.state.enableInput} />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="Last Name" >
                                    {getFieldDecorator('lname', {
                                        initialValue: this.state.student.LastName,
                                    })(<Input disabled="disabled" />)}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout} label="Date of Birth">
                                    {getFieldDecorator('dob', {
                                        initialValue: this.state.student.DateofBirth,
                                        rules: [{
                                            required: true, message: 'Please enter your date of birth!',
                                        }],
                                    })(

                                        <DatePickerDropdown hideYear={true} isUserNew={!this.state.existing} getDOBNew={this.getDateOfBirthNew} sendUserData={this.state.student.DateofBirth} />
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="Tech ID" >
                                    {getFieldDecorator('techID', {
                                        initialValue: this.state.student.TechID,
                                    })(<Input disabled="disabled" />)}
                                </FormItem>
                                {/*------------------------------------------ ADDRESS ------------------------------------------*/}
                                <FormItem style={{ display: 'none' }} {...formItemLayout} label="Street" >
                                    {getFieldDecorator('street', {
                                        initialValue: this.state.student.StreetAddress,
                                        rules: [{
                                            required: false, message: 'Please input street!',
                                        }],
                                    })(<Input disabled={this.state.enableInput} />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="City" >
                                    {getFieldDecorator('city', {
                                        initialValue: this.state.student.City,
                                        rules: [{
                                            required: true, message: 'Please input city!',
                                        }],
                                    })(<Input disabled={this.state.enableInput} />)}
                                </FormItem>


                                <FormItem {...formItemLayout} label="State">
                                    {getFieldDecorator('state', {
                                        initialValue: this.state.student.State,
                                        rules: [
                                            { required: true, message: 'Please select State!' },
                                        ],
                                    })(
                                        <Select
                                            showSearch
                                            style={{ width: '40%' }}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            disabled={this.state.enableInput}
                                        >
                                            {this.stateList}
                                        </Select>)}
                                </FormItem>



                                <FormItem style={{ display: 'none' }} {...midFormItemLayout} label="ZipCode">
                                    {getFieldDecorator('zipcode', {
                                        initialValue: this.state.student.ZipCode,
                                        rules: [{ required: false, message: 'Please input your Zip Code!' }],
                                    })(
                                        <Input type="number" style={{ width: '100%' }} disabled={this.state.enableInput} />
                                    )}
                                </FormItem>
                                {/*------------------------------------------ CONTACT ------------------------------------------*/}
                                <FormItem {...formItemLayout} label="Phone Number">
                                    {getFieldDecorator('phone', {
                                        initialValue: this.state.student.PhoneNumber,
                                    })(
                                        <Input style={{ width: '100%' }} disabled="disabled" />
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout} label="E-mail">
                                    {getFieldDecorator('email', {
                                        initialValue: this.state.student.Email,
                                        rules: [{
                                            type: 'email', message: 'The input is not valid E-mail!',
                                        },
                                        {
                                            validator: this.checkConfirm,
                                        }],
                                    })(
                                        <Input disabled="disabled" />
                                    )}
                                </FormItem>
                                <center>
                                    If their employer or class does not exist make sure to go back and create it first!
                                </center>
                                <FormItem
                                    {...formItemLayout} label="Excel Sheet Employer">
                                    {getFieldDecorator('organization', {
                                        initialValue: this.state.student.Organization
                                    })(
                                        <Input disabled="disabled" />
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="Employer"
                                >
                                    {getFieldDecorator('emp', {
                                        initialValue: this.state.employerValue,
                                        rules: [{
                                            required: true, message: 'Please select an employer!'
                                        }],
                                    })(
                                        <Select
                                            showSearch
                                            style={{ width: '75%' }}
                                            searchPlaceholder="Enter Company Name"
                                            optionFilterProp="children"
                                            onChange={this.getEmployerId}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {this.employerDisplayList}
                                        </Select>)}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout} label="Excel Sheet Class">
                                    {getFieldDecorator('excelClass', {
                                        initialValue: this.state.student.Class
                                    })(
                                        <Input disabled="disabled" />
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="Class"
                                >
                                    {getFieldDecorator('class', {
                                        initialValue: this.state.classValue,
                                        rules: [{
                                            required: true, message: 'Please select a class!'
                                        }],
                                    })(
                                        <Select
                                            showSearch
                                            style={{ width: '75%' }}
                                            searchPlaceholder="Enter Class Name"
                                            optionFilterProp="children"
                                            onChange={this.getClassId}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {this.classDisplayList}
                                        </Select>)}
                                </FormItem>
                                <FormItem {...tailFormItemLayout} >
                                    {/* <button type="submit" className="btn btn-default" onClick={() => { this.props.updateEvent(); }} >Cancel</button> */}
                                    <button type="submit" className="btn btn-default" onClick={event => this.setState({ studentEdit: false })} >Back</button>
                                    <button type="submit" className="btn btn-default" style={{ margin: 5 }}>Update</button>
                                </FormItem>
                            </div>
                        </Form>
                    </Spin>
                </div>
            </div >
        );
    }

    render() {

        return (
            <div>
                {!this.state.studentEdit && <div>
                    <input type="file" onChange={this.onFileChange} />
                    (Make sure file has the extension of .xlsx and not .csv!)
                    <br></br>
                    (If any rows have red text, they are missing important data and should be deleted and reuploaded in a different file.)

                    <br></br>
                    <Link to="/admin/import" onClick={() => { this.exportExcel(); }} >Download Excel File Template</Link>
                    <br></br>
                    <br></br>
                    Filter by File:
                    <Select
                        showSearch
                        style={{ width: '35%', marginTop: '10px', marginBottom: '10px', marginleft: '5px' }}
                        searchPlaceholder="Enter File Name"
                        optionFilterProp="children"
                        onChange={this.filterStudents}
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        defaultValue="All"
                    >
                        {this.fileList}
                    </Select>
                </div>}
                {this.fileData()}
            </div>
        );
    }
}

const WrappedImportForm = Form.create()(ImportForm);

export default WrappedImportForm;



// WEBPACK FOOTER //
// ./src/Admin/ImportStudents.js